<template>
  <div class="text-center mr-2">
    <v-dialog v-model="open" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Atualizar
        </v-btn>
      </template>

      <v-card>
        <v-toolbar elevation="0" class="grey lighten-2">
          <v-card-title class="ml-0 pl-1 text-h5">
            Selecione a imagem
          </v-card-title>

          <v-spacer />

          <v-btn icon @click="open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <VueFileAgent
          style="margin: 10px 10px 0 10px;"
          ref="vueFileAgent"
          :theme="'list'"
          :multiple="true"
          :deletable="true"
          :meta="true"
          :accept="'image/*,.zip'"
          :maxSize="'10MB'"
          :maxFiles="1"
          :helpText="'Escolher imagem de capa'"
          :errorText="{
            type: 'Invalid file type. Only images or zip Allowed',
            size: 'Files should not exceed 10MB in size',
          }"
          @select="filesSelected($event)"
          @beforedelete="onBeforeDelete($event)"
          @delete="fileDeleted($event)"
          v-model="fileRecords"
        ></VueFileAgent>

        <v-divider></v-divider>

        <v-row no-gutters class="lighten-5 pl-4 pr-4 pt-4">
          <v-col md="6" class="pr-2">
            <date-picker
                outlined
                dense
                label="Agendar para"
                clearable
                hide-details
                @change="val => this.schedule_start = val"
            />
          </v-col>
          <v-col md="6" class="pl-2">
            <v-text-field
                outlined
                dense
                label="Horário de início"
                clearable
                type="time"
                @change="val => this.schedule_start_at = val"
            ></v-text-field>
          </v-col>

          <v-alert
              v-if="alertScheduledTask"
              dense
              border="right"
              type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>
        </v-row>

        <v-card-actions>
          <v-btn :loading="loading" color="primary" :disabled="!fileRecordsForUpload.length" @click="uploadFiles">
            Enviar imagem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {handleResponseError} from '@/api/handleError'
import {get} from 'lodash'
import DatePicker from '@/components/DatePicker'
import { TYPE_UPDATE_LOCATION_MEDIA } from '@/constants/tasks'

export default {
  name: 'LocationPhotosModal',
  props: {
    locationName: {
      type: String,
    },
    accountData: {
      type: Object,
    },
    bulk: {
      type: Boolean,
    },
    filters: Object
  },
  computed: {
    ...mapState({
      location: state => state.locations.location,
      imageUploaded: state => state.locationCoverPhotos.imageUploaded,
      imageUploadedError: state => state.locationCoverPhotos.imageUploadedError,
    })
  },
  components: {
    DatePicker
  },
  mounted() {
    if(this.accountData.scheduledTasks) {
      this.accountData.scheduledTasks.map(scheduleTask => {
        console.log(scheduleTask.type)
        if(scheduleTask.type === TYPE_UPDATE_LOCATION_MEDIA) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  watch: {
    imageUploaded(current, previous) {
      if (current && current !== previous) {
        this.open = false
        this.loading = false
        this.showNotification('Imagem salva!', 'success')
        if (this.bulk) {
          const taskId = get(current, 'data.tasks[0].id')
          if (taskId) {
            this.$router.push(`/task/${taskId}`)
          } else {
            this.showNotification('Nenhuma tarefa foi criada.', 'red darken-2')
          }
        } else {
          this.$store.dispatch('locations/getLocation', this.location.data.id)
        }
      }
    },
    imageUploadedError(error) {
      this.loading = false
      if (error) {
        this.showNotification(handleResponseError(error, 'Não foi possível salvar a imagem'), 'red darken-2')
      }
    }
  },
  data: () =>({
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    fileRecords: [],
    loading: false,
    uploadUrl: '/mediaitem',
    uploadHeaders: { 'X-Test-Header': 'vue-file-agent' },
    fileRecordsForUpload: [],
    open: false,
    schedule_start: '',
    schedule_start_at: '',
    alertScheduledTask: null
  }),
  methods: {
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    uploadFiles: function () {
      // Using the default uploader. You may use another uploader instead.
      if(!this.bulk) {
        let formData = new FormData()
        if (this.fileRecordsForUpload[0].file) {
          formData.append('media', this.fileRecordsForUpload[0].file)
        }
        formData.append('schedule_type', TYPE_UPDATE_LOCATION_MEDIA)
        formData.append('schedule_start', this.schedule_start)
        formData.append('schedule_start_at', this.schedule_start_at)
        formData.append('media_format', 'PHOTO')
        formData.append('category', 'COVER')
        formData.append('location_name', this.accountData.name)

        const items = get(this.location, 'data.mediaItems')
        const exists = Array.isArray(items) && items.find(i => {
          if(i.location_association.category === 'COVER') {
            return i
          }
        })

        this.loading = true
        if (exists) {
          formData.append('_method', 'PATCH')
          this.$store.dispatch('locationCoverPhotos/UPDATE_LOCAL_PHOTO', { data: formData, id: exists.id })
        } else {
          this.$store.dispatch('locationCoverPhotos/POST_LOCAL_PHOTO', formData)
        }
      } else {
        const params = {
          ids: this.accountData.ids,
          total: this.accountData.ids.length,
          account: this.accountData.account,
          allSelected: this.accountData.allSelected
        }

        let formData = new FormData()
        if (this.fileRecordsForUpload[0].file) formData.append('media', this.fileRecordsForUpload[0].file)
          formData.append('schedule_start', this.schedule_start)
          formData.append('schedule_start_at', this.schedule_start_at)
          formData.append('media_format', 'PHOTO')
          formData.append('category', 'COVER')
          formData.append('params', JSON.stringify(params))
          formData.append('filters', JSON.stringify(this.filters))

          this.loading = true
          this.$store.dispatch('locationCoverPhotos/POST_LOCAL_PHOTO_BULK', formData)
      }
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    filesSelected: function (fileRecordsNewlySelected) {
      let validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
    },
    onBeforeDelete: function (fileRecord) {
      let i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
      // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        let k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm('Are you sure you want to delete?')) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
  },
}
</script>

<style>

</style>
